import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  UntypedFormArray,
  UntypedFormGroup,
} from '@angular/forms';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { ToasterService } from '../../../../../services/core/toaster.service';
import { ObserverParticipantPopupComponent } from '../../add-task/add-checklist/observer-participant-popup/observer-participant-popup.component';
import { BackendApiService } from '../../../../../services/backend-api.service';

@Component({
    selector: 'app-task-checklists',
    templateUrl: './task-checklists.component.html',
    styleUrls: ['./task-checklists.component.scss'],
    standalone: false
})
export class TaskChecklistsComponent implements OnInit, OnChanges {
  public isImportant: boolean = false;
  public CONST_OBSERVER_TYPE: string = 'observer';
  public CONST_PARTICIPANT_TYPE: string = 'participant';
  @Output() callback = new EventEmitter();
  @Input() checkLists: any;
  @Input() model: any = {};
  @Input() taskId?: number | string; // fallback id when model is not yet ready
  @Input() isLocked: boolean = false;

  public sectionForm: UntypedFormGroup = new UntypedFormGroup({
    checklists: new UntypedFormArray([]),
  });
  constructor(
    public dialog: NgDialogAnimationService,
    private fb: FormBuilder,
    public toasterService: ToasterService,
    public backendApiService: BackendApiService
  ) {}

  ngOnInit(): void {
    console.log('dara onit', this.checkLists);
  }

  /**
   * Resolve task id from model or explicit input
   */
  private getTaskId(): number | string | undefined {
    return this.model?.id ?? this.taskId;
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes);
    this.model = changes.model?.currentValue;
    if (changes.checkLists?.currentValue?.length > 0) {
      if (this.suppressNextChecklistsRebuild) {
        // This [checkLists] update is just the parent echoing back the array we
        // ourselves emitted via getDataForParent() a moment ago — the FormArray
        // already reflects it. Rebuilding here would clear() and re-add every
        // row with edit_mode=false, snapping whichever row the user is actively
        // editing out of edit mode on every keystroke-level interaction
        // (toggling Important, adding an observer, checking a box).
        this.suppressNextChecklistsRebuild = false;
        return;
      }
      this.checklists().clear();
      this.checkLists.forEach((item: any) => {
        this.addChecklist(item, true, false);
      });
    }
  }

  openObserverParticipantPopup(event: any, type: any, index: any) {
    const position = event.target.getBoundingClientRect();
    const dialogRef = this.dialog.open(ObserverParticipantPopupComponent, {
      width: '420px',
      height: '500px',
      // position: {top:`${position.top +26}px`, left: `${position.left}px`},
      data: {
        type: type,
        index: index,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('result', result);
      if (result) {
        if (result.type == this.CONST_OBSERVER_TYPE) {
          this.addUser(result, 'observers');
          // const value = this.checklists().at(result.index)?.get('observers')?.getRawValue();
          // value.push(result.user);
          // this.checklists().at(result.index).get('observers')?.setValue(value);
        } else if (result.type == this.CONST_PARTICIPANT_TYPE) {
          this.addUser(result, 'participants');
          // const value = this.checklists().at(result.index)?.get('participants')?.getRawValue();
          // value.push(result.user);
          // this.checklists().at(result.index).get('participants')?.setValue(value);
        }
      }
    });
  }
  addUser(data: any, type: any) {
    const usersList = this.checklists()
      .at(data.index)
      ?.get(type)
      ?.getRawValue();
    const alreadyExistCheck = usersList.find((x: any) => x.id == data?.user.id);

    if (!alreadyExistCheck) {
      usersList.push(data.user);
      this.checklists().at(data.index)?.get(type)?.setValue(usersList);
      this.updateChecklistAtBackend(data.index);
    }
  }
  removeCheckList(index: any) {
    if (this.isLocked) {
      return;
    }
    const id = this.checklists().at(index).get('id')?.value;
    this.checklists().removeAt(index);
    this.backendApiService.deleteApi('tasks/checklist/' + id).subscribe(
      (response: any) => {
        this.toasterService.showSuccessMessage(response?.data?.message);
        // Emit callback to parent so progress bar updates when checklist item removed
        this.getDataForParent();
      },
      () => {
        this.toasterService.showError('Error', 'Failed to delete checklist');
      }
    );
  }

  isImportantCheckBox(index: any) {
    const value = this.checklists().at(index).get('is_important')?.value;
    if (value == true) {
      this.checklists().at(index).get('is_important')?.setValue(false);
    } else {
      this.checklists().at(index).get('is_important')?.setValue(true);
    }
    // this.isImportant = !this.isImportant;
    this.updateChecklistAtBackend(index);
  }

  checklists(): UntypedFormArray {
    return this.sectionForm.get('checklists') as UntypedFormArray;
  }

  addChecklist(
    checklist: any = '',
    viewMode: boolean = false,
    editMode: boolean = true
  ) {
    this.checklists().push(this.newChecklist(checklist, viewMode, editMode));
  }

  newChecklist(
    checklist: any = '',
    viewMode: boolean = false,
    editMode: boolean = true
  ) {
    return this.fb.group({
      id: [checklist ? checklist?.id : ''],
      text: [checklist ? checklist?.text : 'text'],
      observers: [checklist ? checklist?.observers : []],
      participants: [checklist ? checklist?.participants : []],
      is_completed: [checklist ? checklist?.is_completed : false],
      is_important: [checklist ? checklist?.is_important : false],
      view_mode: [viewMode],
      edit_mode: [editMode],
    });
  }

  /** Set before emitting so ngOnChanges can recognize its own echo, see above. */
  private suppressNextChecklistsRebuild = false;

  getDataForParent() {
    const checklists = this.sectionForm.get('checklists')?.value;
    this.suppressNextChecklistsRebuild = true;
    this.callback.emit(checklists);
  }

  removeUsers(index: any, dataArray: any) {
    dataArray.splice(index, 1);
  }

  /**
   * Colour by person, not by role.
   *
   * A role-based palette gave every participant on a row the same fill, so three
   * participants read as one indistinguishable blob. The role is still carried by
   * the tooltip, which is where it is actually legible.
   *
   * Trade-off: one person holding two roles (Assignee and Participant) now gets
   * two same-coloured badges; the tooltip is what separates them.
   */
  private readonly AVATAR_COLORS: string[] = [
    '#ff6600', '#2563eb', '#14b8a6', '#8b5cf6', '#ec4899', '#f59e0b',
    '#10b981', '#6366f1', '#ef4444', '#0ea5e9', '#84cc16', '#d946ef',
  ];

  /**
   * Task-level assignees, participants, then observers, flattened for the
   * collapsed-row avatar stack. Every checklist row shows the same task-wide
   * People list (matching the task detail sidebar) rather than a per-item
   * assignment. "Assignee" in that sidebar is backed by responsible_persons.
   */
  checklistPeople(index: any) {
    const assignees = (this.model?.responsible_persons || []).map((user: any) => ({
      user,
      role: 'Assignee',
    }));
    const participants = (this.model?.participants || []).map((user: any) => ({
      user,
      role: 'Participant',
    }));
    const observers = (this.model?.observers || []).map((user: any) => ({
      user,
      role: 'Observer',
    }));
    return [...assignees, ...participants, ...observers];
  }

  getInitials(name: string): string {
    return (name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || '')
      .join('');
  }

  /**
   * Stable hash of the user id (name as fallback) so one person keeps the same
   * colour across rows, tabs and reloads rather than shifting with list order.
   */
  getAvatarColor(person: any): string {
    const key = String(person?.user?.id ?? person?.user?.full_name ?? '');
    if (!key) return '#6b7280';
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = (Math.imul(31, hash) + key.charCodeAt(i)) | 0;
    }
    return this.AVATAR_COLORS[Math.abs(hash) % this.AVATAR_COLORS.length];
  }

  /** Set on toolbar mousedown so the following blur does not collapse the row. */
  private suppressBlurCollapse = false;

  onToolbarMouseDown() {
    // mousedown fires before blur. Without this flag the row would collapse to
    // view mode and unmount .bar-tools before + Observer / + Participant /
    // Important / delete could run their click handlers.
    this.suppressBlurCollapse = true;
  }

  onChecklistBlur(index: any) {
    if (this.isLocked) {
      return;
    }
    if (this.suppressBlurCollapse) {
      this.suppressBlurCollapse = false;
      return;
    }
    // Close on focus-out, matching what Enter already does. Empty-row removal
    // stays disabled here (see the commented block in ediViewChecklist).
    this.ediViewChecklist(index, true);
  }

  ediViewChecklist(
    index: any,
    viewMode: boolean = false,
    editMode: boolean = false
  ) {
    const text = this.checklists().at(index).get('text')?.value;
    /*if(!text) {
      this.checklists().removeAt(index);
      return;
    }*/
    if (editMode) {
      this.checklists().at(index).get('edit_mode')?.setValue(true);
      this.checklists().at(index).get('view_mode')?.setValue(false);
    }
    if (viewMode) {
      this.checklists().at(index).get('view_mode')?.setValue(true);
      this.checklists().at(index).get('edit_mode')?.setValue(false);
    }

    if (viewMode) {
      this.getDataForParent();
      this.updateChecklistAtBackend(index);
    }
  }

  onClickAddNewChecklist() {
    const id = this.getTaskId();
    if (!id) {
      this.toasterService.showWarning('Task Id not Found!');
      return;
    }
    this.addChecklist();
    this.saveChecklistAtBackend(this.checklists().length - 1);
  }

  saveChecklistAtBackend(index: any) {
    const id = this.getTaskId();
    if (!id) {
      this.toasterService.showWarning('Task Id not Found!');
      return;
    }
    const checklist = this.checklists().at(index)?.value;
    const data = {
      id: checklist?.id,
      text: checklist?.text,
      observers: checklist?.observers,
      participants: checklist?.participants,
      is_completed: checklist?.is_completed,
      is_important: checklist?.is_important,
      task_id: id,
    };
    this.backendApiService
      .postApi('tasks/add/checklist', data)
      .subscribe((response: any) => {
        console.log('response', response);
        this.checklists()
          .at(index)
          .get('id')
          ?.setValue(response.data?.data?.id);
      });
  }

  updateChecklistAtBackend(index: any) {
    // Wait for Angular to update the FormControl value before emitting
    // This ensures the checkbox state is synchronized before progress calculation
    setTimeout(() => {
      this.getDataForParent();
      console.log('[CHECKLIST] Callback emitted after FormControl sync');
    }, 0);

    const taskId = this.getTaskId();
    if (!taskId) {
      console.log('[CHECKLIST] No model.id - skipping backend update');
      return;
    }

    // Get the updated checklist value (will be synced by the time backend call completes)
    const checklist = this.checklists().at(index)?.value;
    const data = {
      id: checklist?.id,
      text: checklist?.text,
      observers: checklist?.observers,
      participants: checklist?.participants,
      is_completed: checklist?.is_completed,
      is_important: checklist?.is_important,
      // task_id: this.model?.id,
    };
    this.backendApiService
      .patchApi(`tasks/update/checklist/${checklist?.id}`, data)
      .subscribe((response: any) => {
        console.log('[CHECKLIST] Backend update successful', response);
      });
  }
}
